export const nl = {

    upload_max_file : 'U kunt maximaal 3 bestanden uploaden.',
    upload_message : 'Sleep het bestand hierheen of <em>klik om te uploaden.</em>',
    upload_tip_1 : 'U kunt alleen bestanden uploaden in de formaten doc, docx en pdf.',


    notification_warning_title: 'Opgelet!',
    notification_destroy: 'De geselecteerde gegevens zullen permanent worden verwijderd. Wilt u dit goedkeuren?',
    notification_destroy_cancel: 'Het verwijderen is geannuleerd.',
    notification_sending_cancel: 'Het verzenden is geannuleerd.',
    notification_reCaptchaTitle: 'Ik ben geen robot',

    dialog_file_upload_title: 'Bestand Uploaden',
    dialog_file_upload_description: 'Probleemloos afdrukken en hoge afwerkingskwaliteit',
    dialog_offer_title: 'Vraag een Offerte aan',
    dialog_offer_description: 'Probleemloos afdrukken en hoge afwerkingskwaliteit',

    misc_or: 'Of',
    misc_yes: 'Ja',
    misc_no: 'Nee',
    misc_search_not_found: 'Sorry, er zijn geen resultaten gevonden die aan uw zoekopdracht voldoen.',

    inputs_choice: 'Uw Keuze',
    inputs_your_message: 'Uw Bericht...',
    inputs_your_email: 'Uw E-mailadres',
    inputs_email: 'E-mail',
    inputs_first_name: 'Voornaam',
    inputs_last_name: 'Achternaam',
    inputs_your_phone: 'Uw Telefoonnummer',
    inputs_phone: 'Telefoon',
    inputs_country: 'Land',
    inputs_city: 'Stad',
    inputs_town: 'Gemeente',
    inputs_subject: 'Onderwerp',
    inputs_message: 'Bericht',
    inputs_your_full_name: 'Uw Volledige Naam',
    inputs_full_name: 'Volledige Naam',
    inputs_has_access_web_site: 'Ik geef toestemming om op de website te publiceren.',

    button_send: 'Verzenden',
    button_save: 'Opslaan',
}
